import React, { ReactElement } from 'react';
import { withProjectChangeDialog } from 'components/common/withProjectChangeDialog';
import { TemplateCardRefsProvider } from 'contexts/TemplateCardRefsContext';
import { withInspectionTemplatesStore } from 'store/inspection';
import { useTemplateListController } from './controller/useTemplateListController';
import { MemoTemplateListPresentational } from './presentational';
import { MemoTemplateListSkeleton } from './skeleton';
import { StartInspectionDialog } from './components/StartInspectionDialog';

const EntityNotFoundView = React.lazy(
  () => import('views/issue/issueView/EntityNotFoundView')
);

function TemplateList(): ReactElement {
  const {
    showSkeleton,
    showNotFound,
    startInspectionDialogOpen,
    startInspectionDialogTemplate,
    closeStartInspectionDialog,
    submitStartInspection,
    startInspectionSubmitting,
    presentationalProps,
  } =
    useTemplateListController();

  if (showSkeleton) {
    return <MemoTemplateListSkeleton />;
  }

  if (showNotFound) {
    return (
      <React.Suspense fallback={<MemoTemplateListSkeleton />}>
        <EntityNotFoundView entity='template' />
      </React.Suspense>
    );
  }

  return (
    <>
      <MemoTemplateListPresentational {...presentationalProps} />
      <StartInspectionDialog
        open={startInspectionDialogOpen}
        template={startInspectionDialogTemplate}
        isSubmitting={startInspectionSubmitting}
        onClose={closeStartInspectionDialog}
        onStart={submitStartInspection}
      />
    </>
  );
}

const TemplateListWithProviders = () => (
  <TemplateCardRefsProvider>
    <TemplateList />
  </TemplateCardRefsProvider>
);

export const MemoTemplateList = React.memo(
  withInspectionTemplatesStore(
    withProjectChangeDialog(TemplateListWithProviders)
  )
);
